module.exports = __webpack_public_path__ + "img/portraits_15_V.e308be87.webp";